import { Typography } from '@material-ui/core';
import { Inline, Stack, useSnackbarStack } from '@superdispatch/ui';
import { Box, Button } from '@superdispatch/ui-lab';
import { trackEvent } from 'shared/helpers/Analytics';
import { useInstantTransferReminder } from 'shared/modules/superpay/SuperPayAPI';
import { useInstantTransferBannerAccessTime } from './useInstantTransferBannerAccessTime';

interface InstantTransferReminderContentProps {
  onClose: () => void;
  onAlwaysClosed: () => void;
}

export function InstantTransferReminderContent({
  onClose,
  onAlwaysClosed,
}: InstantTransferReminderContentProps) {
  const { addSnackbar } = useSnackbarStack();
  const { setNextDay } = useInstantTransferBannerAccessTime();

  const { mutate: setAlwaysClosed } = useInstantTransferReminder({
    onSuccess() {
      onAlwaysClosed();
    },
    onError(error) {
      addSnackbar(error.message || 'An unexpected error happened. Try again.', {
        variant: 'error',
      });
    },
  });

  const onDismissNow = () => {
    setNextDay();
    onClose();
    addSnackbar('Instant Transfer Reminders Snoozed.');
  };

  return (
    <Box
      paddingLeft="medium"
      paddingRight="medium"
      paddingTop="small"
      paddingBottom="small"
    >
      <Stack space="medium">
        <Stack space="small">
          <Typography variant="h3">
            Turn Off Instant Transfer Reminders?
          </Typography>
          <Typography>
            Would you like to snooze this reminder for now, or stop receiving it
            completely?
          </Typography>
        </Stack>
        <Inline space="small" horizontalAlign="center" noWrap={true}>
          <Button variant="neutral" onClick={() => setAlwaysClosed()}>
            Don&apos;t Show Me Again
          </Button>

          <Button
            onClick={() => {
              onDismissNow();
              trackEvent(
                'Carrier Clicked Dismiss Now on Instant Transfer Reminder',
              );
            }}
          >
            Dismiss Now
          </Button>
        </Inline>
      </Stack>
    </Box>
  );
}
